<tui-root *tuiLet="fullscreenMode$ | async as fullscreenMode" class="page">
  <sgp-fullscreen-watcher></sgp-fullscreen-watcher>
  <div class="page__header" [class.page__header--fullscreen]="fullscreenMode">
    <app-header [hideNotifications]="false" [hideSearch]="false"></app-header>
  </div>
  <div class="page__content" [class.page__content--fullscreen]="fullscreenMode">
    <router-outlet></router-outlet>
  </div>
</tui-root>
